// import components
import { Dialog } from 'components/shared';
import DutyInformationDialogTopSpecs from './DutyInformationDialogTopSpecs';
import { Tab, Tabs } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import DutyHistoryAudit from './DutyHistoryAudit';
import DutyHistoryPeriodsAudit from './DutyHistoryPeriodsAudit';

// import external libraries
import { useTranslation } from 'react-i18next';

// import hooks
import { SyntheticEvent, useState } from 'react';

// import types
import { DutyInformationDialogProps } from './DutyInformationDialog.types';
import DutyOtherSettings from './DutyOtherSettings';
import { isRowNominal } from '../HoursTable.utils';

const DutyInformationDialog = ({
  isOpen,
  onClose,
  currentRowId,
  rows,
  employeeId,
  isEmployeePortal = false
}: DutyInformationDialogProps) => {
  const row = rows?.find((row) => row.id === currentRowId);

  const { t } = useTranslation('common', {
    keyPrefix: 'hoursTable.dutyInformation'
  });
  const { t: tRoot } = useTranslation('common');
  const [tab, setTab] = useState('dutyOtherSettings');

  const handleClose = () => {
    setTab('dutyOtherSettings');
    onClose?.();
  };

  const handleTabChange = (event: SyntheticEvent, newValue: string) => {
    setTab(newValue);
  };

  if (!row) return null;

  return (
    <Dialog
      open={isOpen}
      title={t('title')}
      handleClose={handleClose}
      maxWidth="medium"
      slotProps={{
        paper: {
          sx: {
            minWidth: '60%',
            maxWidth: '600px',
            maxHeight: 'calc(100% - 200px)'
          }
        }
      }}
    >
      <DutyInformationDialogTopSpecs row={row} />
      <TabContext value={tab}>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
          aria-label="Duty information tabs"
        >
          <Tab value="dutyOtherSettings" label={t('otherSettings')}></Tab>
          <Tab value="dutyHistory" label={t('dutyHistory')}></Tab>
          {!isRowNominal(row) && (
            <Tab value="periods" label={tRoot('periods')} />
          )}
        </Tabs>

        <TabPanel value="dutyOtherSettings">
          <DutyOtherSettings
            key={row?.dutyLineId} // Ensure the component re-renders when the row changes
            row={row}
            isEmployeePortal={isEmployeePortal}
            employeeId={employeeId}
          />
        </TabPanel>
        <TabPanel value="dutyHistory">
          <DutyHistoryAudit isOpen={isOpen} row={row} employeeId={employeeId} />
        </TabPanel>
        {!isRowNominal(row) && (
          <TabPanel value="periods">
            <DutyHistoryPeriodsAudit
              isOpen={isOpen}
              row={row}
              employeeId={employeeId}
            />
          </TabPanel>
        )}
      </TabContext>
    </Dialog>
  );
};

export default DutyInformationDialog;
